import React, { ReactNode } from 'react';
import { AnimatePresence } from 'motion/react';
import * as motion from 'motion/react-m';

import { Box } from '@osmosis/tailwind-ui/components/Box';
import { P } from '@osmosis/tailwind-ui/components/Text';
import { BoxProps } from '@osmosis/tailwind-ui/components/Box';
import { InputProps } from '@osmosis/tailwind-ui/components/Input';

import Message from './Message';

type Props = {
  error?: boolean;
  errorMessage?: string | ReactNode;
  messageProps?: BoxProps | InputProps;
};

/**
 * InputValidationMessage.
 */
const InputValidationMessage = (props: Props) => {
  const { error, errorMessage, messageProps } = props;

  return (
    <AnimatePresence>
      {error && (
        <motion.div
          key="message"
          initial={{
            translateY: -10,
            opacity: 0,
            height: 0,
          }}
          animate={{ translateY: 0, opacity: 1, height: 'auto' }}
          exit={{
            translateY: -10,
            opacity: 0,
            height: 0,
            transition: { ease: 'easeInOut' },
          }}
        >
          {errorMessage && (
            <Box className={`pt-2`}>
              <Message cn="bg-red-100" {...messageProps}>
                <P className={`text-red-700 dark:text-red-300 font-bold p-2`}>
                  {errorMessage}
                </P>
              </Message>
            </Box>
          )}
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default InputValidationMessage;
